import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleDownloadOverallReport = async (event_id, dispatch) => {
  let reportWindow;
  let fileUrl;
  try {
    // Reserve the tab during the user's confirmation, before the API request
    // outlasts the browser's permission to open a popup.
    reportWindow = window.open("about:blank", "_blank");
    if (!reportWindow) {
      ErrorToast("Your browser blocked the report tab. Allow pop-ups for this site and try again.");
      return null;
    }
    reportWindow.opener = null;
    reportWindow.document.title = "Preparing overall report";
    reportWindow.document.body.textContent = "Preparing your overall report. Please keep this tab open.";
    reportWindow.document.body.style.cssText = "font:16px/1.6 sans-serif;padding:24px;color:#164e48;";

    dispatch(setShowPreloader(true));
    const reportResponse = await AxiosGetMethod(
      `org/event/overall-report?event_id=${event_id}`,
    );
    const html = reportResponse.data?.data?.html;

    if (reportResponse.status === 201 && typeof html === "string" && html.trim()) {
      if (reportWindow.closed) {
        ErrorToast("The report tab was closed. Please download the report again and keep the tab open.");
        return null;
      }
      const blob = new Blob([html], { type: "text/html;charset=utf-8" });
      fileUrl = URL.createObjectURL(blob);
      reportWindow.location.replace(fileUrl);
      reportWindow.focus();
      // Give the new document time to load before releasing its Blob URL.
      const openedUrl = fileUrl;
      window.setTimeout(() => URL.revokeObjectURL(openedUrl), 60000);
      SuccessToast("Overall report print view opened.");
      return true;
    }

    if (!reportWindow.closed) reportWindow.close();
    if (reportResponse.status === 401) HandleLogout();
    else ErrorToast(reportResponse.data?.message || "Unable to open overall report print view.");
  } catch (error) {
    if (fileUrl) URL.revokeObjectURL(fileUrl);
    if (reportWindow && !reportWindow.closed) reportWindow.close();
    ErrorToast("Unable to open overall report print view. Please try again.");
  } finally {
    dispatch(setShowPreloader(false));
  }

  return null;
};

export default handleDownloadOverallReport;
